import { render, staticRenderFns } from "./jobManagement.vue?vue&type=template&id=2e532cbe&scoped=true&"
import script from "./jobManagement.vue?vue&type=script&lang=js&"
export * from "./jobManagement.vue?vue&type=script&lang=js&"
import style0 from "./jobManagement.vue?vue&type=style&index=0&id=2e532cbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e532cbe",
  null
  
)

export default component.exports